/* LFC · cadeau e-book automatique
   Quand une fontaine est au panier, on ajoute le guide 0 € (variant 57767032291676)
   pour que Digital Downloads livre le PDF. On le retire si plus aucune fontaine.
   Idempotent : ne fait rien si l'état est déjà correct (pas de boucle). */
(function () {
  const GIFT_VARIANT = 57767032291676;
  const GIFT_HANDLE = 'produit-numerique';
  const FONTAINE_PREFIX = 'fontaine-';
  let busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function hasFontaine(cart) {
    return (cart.items || []).some((i) => (i.handle || '').indexOf(FONTAINE_PREFIX) === 0);
  }
  function findGift(cart) {
    return (cart.items || []).find((i) => i.handle === GIFT_HANDLE || i.id === GIFT_VARIANT);
  }

  function sectionIds() {
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map((s) => s.id);
    }
    return [];
  }

  async function cartPost(url, body) {
    const ids = sectionIds();
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

    // met à jour l'UI du tiroir si présent
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function' && res && res.sections) {
      d.renderContents(res);
    }
    return res;
  }

  async function reconcile() {
    if (busy || !window.Shopify) return;
    busy = true;
    let changed = false;
    try {
      const cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const fontaine = hasFontaine(cart);
      const gift = findGift(cart);

      if (fontaine && !gift) {
        await cartPost('cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1 }] });
        changed = true;
      } else if (!fontaine && gift) {
        await cartPost('cart/change.js', { id: gift.key, quantity: 0 });
        changed = true;
      } else if (fontaine && gift && gift.quantity > 1) {
        await cartPost('cart/change.js', { id: gift.key, quantity: 1 });
        changed = true;
      }
    } catch (e) {
      /* silencieux : ne jamais bloquer le panier */
    } finally {
      busy = false;
    }

    // sur la page /cart (hors tiroir), un refresh léger reflète la ligne ajoutée/retirée
    if (changed && /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
      window.location.reload();
    }
  }

  function start() {
    reconcile();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcile());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
